<template>
  <Transition
    enter-active-class="transition-all duration-300 ease-out"
    enter-from-class="opacity-0 -translate-y-1"
    enter-to-class="opacity-100 translate-y-0"
  >
    <div
      v-if="error"
      :class="[
        'mt-2 ml-1 block w-full text-left text-[0.75rem] font-bold tracking-wide text-red-500/90 italic',
        errorClassName
      ]"
    >
      <span class="mr-1 select-none">✕</span> {{ error }}
    </div>
  </Transition>
</template>

<script lang="ts" setup>
interface Props {
  error?: string;
  errorClassName?: string | string[] | Record<string, boolean>;
}

withDefaults(defineProps<Props>(), {
  error: "",
  errorClassName: "",
});
</script>